
/**
 * ARTOBJECT listing
 */
export const OBJECT_SCROLL_DISTANCE = 200;
// how many artobjects are visible on start
export const VISIBLE_ON_START = 3;

/**
 * ### Class names ###
 */
export const classNames = {
  CHAPTER_INTRO_HIDE: 'chapter-intro-hide',
  CHAPTER_INTRO_HIDDEN: 'chapter-intro-hidden',
  CHAPTER_READY: 'chapter-ready',
  CHAPTER_LISTING: 'chapter-listing',
  CHAPTER_OBJECTS_FOOTER: 'chapter-objects-footer',
  OBJECT: 'artobject-list-main',
  OBJECT_VISIBLE: 'is-visible',
  OBJECT_ACTIVE: 'is-active',
  OBJECT_FIXED: 'is-fixed',
  OBJECT_HIDING: 'is-hiding',
  ITEM_NAV_NEXT: 'nav-next-view',
  LENIS_FORCE_SCROLLING: 'pt-force-scrolling',
  LAZY_IMAGE: 'lazy-image-wrapper',
  LAZY_IMAGE_LOADING: 'lazy-image-loading',
  LAZY_IMAGE_LOADED: 'lazy-image-loaded',
  IMAGE_ZOOM_ON: 'image-zoom-on',
  IMAGE_LINK_ZOOMED: 'is-zoomed',
  ZOOMED_IMAGE_WRAPPER: 'zoomed-image-wrapper',
  // Artobject offcanvas gallery
  OBJECT_GALLERY_LOADING: 'object-gallery-loading',
}


export const easeInOutCubic = (x) => {
  return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
}